import { FC } from 'react';
import {
  AnswerApplicationQuestionRequest,
  FieldObject,
  FieldObjectTypeEnum,
} from '../../../../openapi/atlantis';
import ConfigDrivenFormInputsV2 from './ConfigDrivenFormInputsV2';

interface ConfigDrivenFieldsV2Props {
  fields?: FieldObject[];
  questionAlias?: string;
  checklistItemId?: string;
  isSubmitting: boolean;
  onSubmit: (e: AnswerApplicationQuestionRequest) => void;
  onNavigateToQuestion?: (questionId: string) => Promise<void>;
}

const ConfigDrivenFieldsV2: FC<ConfigDrivenFieldsV2Props> = ({
  fields = [],
  questionAlias,
  checklistItemId,
  isSubmitting,
  onSubmit,
  onNavigateToQuestion,
}) => {
  return (
    <div className='w-full'>
      {fields
        ?.filter((field) => field?.type !== FieldObjectTypeEnum.Button)
        ?.map((field: any) => (
          <ConfigDrivenFormInputsV2
            key={field.id}
            field={field}
            questionAlias={questionAlias}
            checklistItemId={checklistItemId!}
            isSubmitting={isSubmitting}
            onSubmit={onSubmit}
            onNavigateToQuestion={onNavigateToQuestion}
          />
        ))}
    </div>
  );
};

export default ConfigDrivenFieldsV2;
